/* eslint-disable react/no-unused-state */
import React from 'react'
import _ from 'lodash'
import { ISubscriptionPackageList, SubscriptionPackageListItems } from 'x/index'
import * as util from 'x/utils/util'
import * as NavActions from 'x/utils/navigation'
import { ISelectedAddOn } from './BasePaymentSubscriptionView'

interface IBaseSelectedAddOnViewProps {
  // @ts-ignore
  subscription: any
}

interface IBaseSelectedAddOnViewState {
  subscriptionPackageList: ISubscriptionPackageList
  selectedPackage: SubscriptionPackageListItems
  addOnList: SubscriptionPackageListItems[]
  selectedAddOnlist: ISelectedAddOn[]
  mode: 'upgrade' | 'buy_package' | 'add_on' | 'continue_package'

  isEditing: boolean
}

export default abstract class BaseSelectedAddOnView extends React.Component<IBaseSelectedAddOnViewProps, IBaseSelectedAddOnViewState> {
  // abstract async handleSubmitForm(response: any): Promise<void>
  // abstract didMountCheckPermissionForPhone?: () => void
  // validationSchema: Yup.ObjectSchema<any>
  // imgManagerIDRef: React.RefObject<any>
  // webview: React.RefObject<any>
  // mainPackageItems: any

  constructor(props) {
    super(props)
    this.state = {
      subscriptionPackageList: null,
      selectedPackage: null,
      addOnList: null,
      selectedAddOnlist: null,
      mode: 'buy_package',
      isEditing: false,
    }
  }

  async componentDidMount() {
    await this._initData()
    this._addOnDubledNav()
  }

  _addOnDubledNav = () => {
    const params = this._getParams()
    const { addOnDubledNav } = params
    if (!_.isNil(addOnDubledNav) && addOnDubledNav === 'order_count_quota') {
      this._navToSelectedAddOnListView()
    }
  }

  _initData = async () => {
    const params = this._getParams()
    const { subscriptionPackageList, sku, selectedPackage, selectedAddOn, mode } = params
    const { items } = subscriptionPackageList
    // console.log('_initData selectedPackage => ', selectedPackage)
    // console.log('sku => ', sku)
    // Filter items that start with the given SKU
    const listAddOnOrder = items.filter((item: SubscriptionPackageListItems) => item.sku.startsWith(sku))
    // Get the key from the first item
    const key = listAddOnOrder[0]?.item_subtype

    // Sort addOnList by the specified key in ascending order
    // const sortedAddOnList = _.orderBy(listAddOnOrder, [`data_json.${key}`], ['asc'])

    const mainPackageType = util.getSubscriptionPackageTypeByPackageName(selectedPackage.item_subtype)
    // const subscriptionTsku = this._getAddOnTskuByPackageType(subscriptionPackageList, mainPackageType)
    const sortedAddOnListByMainPackage = util.getAddOnListCanBuyFromMainPackageSelectedPackage(
      subscriptionPackageList,
      mainPackageType,
      sku
    )
    // console.log('sortedAddOnListByMainPackage => ', sortedAddOnListByMainPackage)
    // console.log('mainPackageType => ', mainPackageType)
    const addOnList = []
    let selectedAddOnlist = []
    // If the key is 'order_count_quota', initialize addOnList with a placeholder item
    if (key === 'order_count_quota') {
      // ให้แทรก item ที่ไม่มี sku เพื่อให้เลือกแพ็กเสริมแบบไม่เลือกตัวเลือกได้
      addOnList.push({ sku: null })

      // Add each sorted item to the addOnList
      sortedAddOnListByMainPackage.forEach((item) => {
        addOnList.push(item)
      })
      selectedAddOnlist = selectedAddOn
      // console.log('sku => ', sku)
      // console.log('addOnList => ', addOnList)
    } else {
      const { subscription } = this.props
      const remainingBillingCycle = subscription.has('remaining_billing_cycle') ? subscription.get('remaining_billing_cycle') : null

      const maxBillingCycle =
        !_.isNil(remainingBillingCycle) && remainingBillingCycle > 0 ? remainingBillingCycle : selectedPackage.billing_cycle
      sortedAddOnListByMainPackage.forEach((item) => {
        addOnList.push(item)
        selectedAddOnlist.push({ sku: item.sku, billing_cycle: maxBillingCycle, qty: 0 })
      })
      if (!_.isNil(selectedAddOn)) {
        selectedAddOnlist = selectedAddOnlist.map((addOn) => {
          const matchedAddOn = selectedAddOn.find((selectedAddOnItem) => selectedAddOnItem.sku === addOn.sku)
          if (matchedAddOn) {
            return { ...addOn, qty: matchedAddOn.qty, billing_cycle: matchedAddOn.billing_cycle }
          }
          return addOn
        })
      }
    }
    // Update the state with the sorted add-on list
    await util.setStatePromise(this, { subscriptionPackageList, selectedPackage, addOnList, selectedAddOnlist, mode })
  }

  _getParams = () => {
    // @ts-ignore
    const params = util.getNavParams(this.props)
    return params
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  goBack = () => {
    // @ts-ignore
    util.navGoBack(this.props)
  }

  _getLabelUnit = (key: string) => {
    let label = ''
    switch (key) {
      case 'order_count_quota':
        label = 'ออเดอร์'
        break
      case 'mkp_quota':
        label = 'ช่องทางขาย'
        break
      case 'ug_quota':
        label = 'กลุ่มสมาชิก'
        break
      case 'pg_quota':
        label = 'รายการราคา'
        break
      case 'helper_count':
        label = 'ผู้ช่วยร้าน'
        break
      case 'store_count':
        label = 'ร้านค้า'
        break
      default:
        label = ''
        break
    }
    return label
  }

  _getSelectedAddOn = (sku: string) => {
    if (_.isNil(sku)) {
      return null
    }
    const { subscriptionPackageList } = this.state
    const { items } = subscriptionPackageList
    let selectedAddOn = null
    items.forEach((item) => {
      if (item.sku === sku) {
        selectedAddOn = item
      }
    })
    return selectedAddOn
  }

  _onPressMinusBtn = () => {
    const { selectedAddOnlist } = this.state
    if (_.isNil(selectedAddOnlist) || selectedAddOnlist.length === 0) {
      return
    }
    const selectedAddOn = selectedAddOnlist[0]
    const newSelectedAddOn = _.cloneDeep(selectedAddOn)
    newSelectedAddOn.billing_cycle -= 1
    this.setState({ selectedAddOnlist: [newSelectedAddOn], isEditing: true })
  }

  _onPressPlusBtn = () => {
    const { selectedAddOnlist } = this.state
    if (_.isNil(selectedAddOnlist) || selectedAddOnlist.length === 0) {
      return
    }
    const selectedAddOn = selectedAddOnlist[0]
    const newSelectedAddOn = _.cloneDeep(selectedAddOn)
    newSelectedAddOn.billing_cycle += 1
    this.setState({ selectedAddOnlist: [newSelectedAddOn], isEditing: true })
  }

  _onPressPlusBtnByAddOnPackage = (index: number) => {
    const { selectedAddOnlist } = this.state
    const newSelectedAddOnlist = _.cloneDeep(selectedAddOnlist)
    newSelectedAddOnlist[index].qty += 1
    this.setState({ selectedAddOnlist: newSelectedAddOnlist, isEditing: true })
  }

  _onPressMinusBtnByAddOnPackage = (index: number) => {
    const { selectedAddOnlist } = this.state
    const newSelectedAddOnlist = _.cloneDeep(selectedAddOnlist)
    newSelectedAddOnlist[index].qty -= 1
    this.setState({ selectedAddOnlist: newSelectedAddOnlist, isEditing: true })
  }

  _getSumResult = () => {
    const { selectedAddOnlist } = this.state
    let result = 0
    selectedAddOnlist.forEach((item) => {
      const { sku } = item
      if (!_.isNil(sku)) {
        const selectedAddOn = this._getSelectedAddOn(sku)
        result += selectedAddOn.price_with_vat * item.qty * item.billing_cycle
      }
    })
    return result
  }

  _callBackFormSelectedAddOn = (selectedAddOn: SubscriptionPackageListItems) => {
    const { selectedPackage, mode } = this.state
    if (selectedAddOn.sku === null) {
      this.setState({
        selectedAddOnlist: [],
      })
    } else {
      const { subscription } = this.props
      const remainingBillingCycle = subscription.has('remaining_billing_cycle') ? subscription.get('remaining_billing_cycle') : null
      // const maxBillingCycle = _.isNil(remainingBillingCycle) ? selectedPackage.billing_cycle : remainingBillingCycle

      let maxBillingCycle =
        !_.isNil(remainingBillingCycle) && remainingBillingCycle > 0 ? remainingBillingCycle : selectedPackage.billing_cycle
      if (mode === 'continue_package') {
        maxBillingCycle = selectedPackage.billing_cycle
      }

      this.setState({
        selectedAddOnlist: [
          {
            sku: selectedAddOn.sku,
            billing_cycle: maxBillingCycle,
            qty: 1,
          },
        ],
        isEditing: true,
      })
    }
  }

  _navToSelectedAddOnListView = () => {
    // @ts-ignore
    const { navigation } = this.props
    const { addOnList } = this.state
    // ถ้าเป็น order_count_quota เช็กว่ามีแค่ตัวเดียวไหม ถ้ามีมากกว่า 1 ตัว ให้ไปหน้าเลือกแพ็กเสริม
    // if (addOnList.length === 1 && addOnList[0].sku === null) {
    //   p.op.showConfirmationOkOnly('', 'ไม่มีแพ็กเสริมให้เลือก')
    //   return
    // }
    navigation.dispatch(
      NavActions.navToSelectedAddOnListView({
        addOnList,
        callBackFormSelectedAddOn: (selectedAddOn) => this._callBackFormSelectedAddOn(selectedAddOn),
      })
    )
    this.setState({ isEditing: true })
  }

  _onPressFooter = () => {
    const { mode, selectedPackage } = this.state
    const { callBackFromSelectedAddOn, sku } = this._getParams()
    if (_.isFunction(callBackFromSelectedAddOn)) {
      const { selectedAddOnlist } = this.state
      // console.log('selectedAddOnlist => ', selectedAddOnlist)
      if (!_.isNil(selectedAddOnlist) && selectedAddOnlist.length > 0) {
        const newSelectedAddOnlist = []
        selectedAddOnlist.forEach((addOn) => {
          if (addOn.qty !== 0) {
            const addOnData = !_.isNil(selectedAddOnlist) && selectedAddOnlist.length > 0 ? selectedAddOnlist[0] : null
            const selectedAddOn = this._getSelectedAddOn(
              !_.isNil(addOnData) && _.has(addOnData, 'sku') && !_.isNil(addOnData.sku) ? addOnData.sku : null
            )
            const isLifeTime = !_.isNil(selectedAddOn) && _.has(selectedAddOn, 'item_type') && selectedAddOn.item_type === 'addon_lifetime'
            // ถ้าเป็นแพ็กเสริมแบบ lifetime ให้ใช้ billing_cycle ของแพ็กหลักในโหมด continue_package (ต่อแพ็กเกจ)
            if (mode === 'continue_package' && isLifeTime) {
              newSelectedAddOnlist.push({
                sku: addOn.sku,
                billing_cycle: selectedPackage.billing_cycle,
                qty: addOn.qty,
              })
            } else {
              newSelectedAddOnlist.push(addOn)
            }
          }
        })
        callBackFromSelectedAddOn(newSelectedAddOnlist, sku)
      } else {
        callBackFromSelectedAddOn(selectedAddOnlist, sku)
      }
    }
    this.goBack()
  }

  _getAddOnPackageInCurrentPackageBillingCycle = () => {
    const { subscription } = this.props
    const params = this._getParams()
    const { sku } = params
    const subscriptionJs = subscription.toJS()
    const { current_package_billing_cycle } = subscriptionJs
    if (_.isNil(current_package_billing_cycle) || current_package_billing_cycle === 0) {
      return null
    }
    const ADD_ON_CURRENTS = []
    current_package_billing_cycle.forEach((packageAddon) => {
      if (packageAddon.sku.startsWith(sku)) {
        ADD_ON_CURRENTS.push(packageAddon)
      }
    })
    // console.log('ADD_ON_CURRENTS => ', ADD_ON_CURRENTS)
    return ADD_ON_CURRENTS
  }

  _getTotalCountUnitInCurrentPackageBillingCycle = () => {
    const { subscription } = this.props
    const { addOnList } = this.state
    const params = this._getParams()
    const { sku } = params
    const subscriptionJs = subscription.toJS()
    const { current_package_billing_cycle } = subscriptionJs
    if (_.isNil(current_package_billing_cycle) || current_package_billing_cycle === 0) {
      return 0
    }
    let itemSubType = 'order_count_quota'
    if (addOnList[0].sku !== null) {
      itemSubType = addOnList[0].item_subtype
    }
    // console.log('current_package_billing_cycle => ', current_package_billing_cycle)
    let totalUnit = 0
    current_package_billing_cycle.forEach((packageAddon) => {
      if (packageAddon.sku.startsWith(sku)) {
        totalUnit += packageAddon.data_json[itemSubType] * packageAddon.qty
      }
    })
    // console.log('ADD_ON_CURRENTS => ', ADD_ON_CURRENTS)
    return totalUnit
  }

  _getSumTotalUnitSelectedAddOn = () => {
    const { selectedAddOnlist, addOnList } = this.state
    if (_.isNil(selectedAddOnlist) || selectedAddOnlist.length === 0) {
      return 0
    }
    // console.log('selectedAddOnlist => ', selectedAddOnlist)
    let itemSubType = 'order_count_quota'
    if (addOnList[0].sku !== null) {
      itemSubType = addOnList[0].item_subtype
    }
    let result = 0
    selectedAddOnlist.forEach((item) => {
      const { sku } = item
      if (!_.isNil(sku)) {
        const selectedAddOn = this._getSelectedAddOn(sku)
        result += selectedAddOn.data_json[itemSubType] * item.qty
      }
    })
    return result
  }
}
